// extracted by mini-css-extract-plugin
export default {"title":"_263e740409","bld":"ba50f95d35"};